import { Avatar, Box, Grid, Typography } from "@material-ui/core";
import MaterialTable from "material-table";
import React, { useContext, useEffect, useReducer, useState } from "react";
import { Alert } from "@material-ui/lab";
import clsx from "clsx";
import TableAction from "../../actions/table_actions";
import tableIcons, {
  options,
} from "../../components/universal/table_attributes";
import UserService from "../../lib/services/api/admin/users/user_client";
import tableReducer, {
  INITIAL_TABLE_STATE,
} from "../../reducers/table_reducer";
import { ToastMessageContext } from "../../lib/contexts/message_context";
import { useStyles } from "./";
import ManageUserCompliance from "./UserCompliance/ManageUserCompliance";
import { getComplianceAlertClass } from "../../lib/utils/complianceColorHelper";

function LineManagerUsers({ user }) {
  const classes = useStyles();
  const [tableState, dispatch] = useReducer(tableReducer, INITIAL_TABLE_STATE);
  const { page, totalCount, pageSize, searchText, inProgress, data } =
    tableState;
  const [lmUsers, setLmUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isComplianceOpen, setIsComplianceOpen] = useState(false)
  const [users, setUsers] = useState([]);
  const [currentSelection, setCurrentSelection] = useState({})
  // console.log("arary is==================", lmUsers?.length)


 

  const tableOptions = {
    ...options,
    page: page,
    search: false,
    total: totalCount,
    paging: false,
    pageSize: pageSize,
    searchText: searchText,
  };

  useEffect(() => {
    setLoading(true)
    const params = {
      user_id: user.id
    }
    UserService.getLineManagerUsers(params).then(res => {
      setLmUsers(res.data)
    }).catch(() => { }).finally(() => { setLoading(false) })



  }, []);

  // const getLimeManagerUsers = () => {
  //   setLoading(false);
  //   const params = {
  //     id: user.id,
  //     page: page + 1,
  //     count_per_page: pageSize,
  //   };
  //   TableAction.getList(dispatch, message, params, "users");
  // };

  // useEffect(() => {
  //   getLimeManagerUsers();
  // }, [pageSize, page, searchText, totalCount]);


  const columns = [
    {
      width: 100,
      title: "Name",
      field: "user_name",
      render: (rowData) => (
        <Box display="flex" justifyContent="flex-start" alignItems="center">
          <Avatar
            src={rowData?.profile_img}
          />
          &nbsp;&nbsp;&nbsp;
          {rowData.user_name}
        </Box>
      ),
      headerStyle: {
        textAlign: "left",
        paddingLeft: 70,
      },
      cellStyle: {
        textAlign: "left",
        paddingLeft: 25,
      },
    },
    {
      title: "Compliance Status",
      field: "color",
      render: (rowData) => (
        <Box
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          mt={0}
        >
          <Alert
            className={clsx(
              classes.alertWrapper,
              classes[getComplianceAlertClass(rowData?.color)]
            )}
            icon={false}
          >
            {rowData?.message}
          </Alert>
        </Box>
      ),
      headerStyle: {
        textAlign: "center",
      },
      cellStyle: {
        textAlign: "left",
        paddingLeft: -100,
        paddingRight: 20,
        width: "70%",
      },
    },
  ];

  // sorting user according to the color
  // red (expired) => amber (low) => green (good)
  const sortUsers = (users) => {
    const redUsers = [];
    const amberUsers = [];
    const greenUsers = [];

    users &&
      users.forEach((item) => {
        const color = item.color?.toLowerCase() || "";
        if (color === "red") {
          redUsers.push(item);
        } else if (color === "amber") {
          amberUsers.push(item);
        } else if (color === "green") {
          greenUsers.push(item);
        }
      });

    return [
      ...redUsers,
      ...amberUsers,
      ...greenUsers,
    ];
  };

  useEffect(() => {
    const { users } = data;

    if (users) {
      const sortedUsers = sortUsers(users);
      setUsers(sortedUsers);
    }
  }, [data]);

  return (
    <Grid xs={12} md={12}>
      <Box mt={2}>
        <Typography variant="h6" color="primary">
          You have {lmUsers?.length || 0} reports and their status is
        </Typography>
      </Box>
      <Box mt={2}>
        <MaterialTable
          style={{ boxShadow: "0px 1px 3px #00000033", paddingRight: "0px" }}
          icons={tableIcons}
          title={<Typography color="primary" variant="subtitle2"></Typography>}
          options={{
            ...tableOptions,
            toolbar: false,
            headerStyle: { height: 50 },
            maxBodyHeight: "350px"
          }}
          data={lmUsers || []}
          isLoading={loading}
          columns={columns}
          onChangePage={(page) => {
            TableAction.setPage(dispatch, page);
          }}
          onChangeRowsPerPage={(pageSize) => {
            TableAction.setPageSize(dispatch, pageSize);
          }}
          onSearchChange={(search) => {
            TableAction.setSearchText(dispatch, search);
          }}
          totalCount={totalCount}
          page={page}
          onRowClick={(event, rowData) => {
            setCurrentSelection(rowData)
            setIsComplianceOpen(true)
          }}
        />
      </Box>
      {isComplianceOpen &&
        <ManageUserCompliance currentSelection={currentSelection} handleClose={() => setIsComplianceOpen(false)} id={currentSelection?.user_id} />

      }
    </Grid>
  );
}

export default React.memo(LineManagerUsers);
